<!--
作成済のプロジェクト表示
-->
<template>
  <v-main class="pa-0">
    <div class="pa-4 d-flex">
      <p class="mb-0 pagetitle">作成済の{{ $t("プロジェクト") }}表示</p>
      <v-spacer></v-spacer>
      <v-icon v-if="device==='pc'" x-large @click="$emit('closeProfile')">mdi-close</v-icon>
    </div>
    <v-card v-if="displayque.length == 0">
      <v-card-text>このユーザーは{{ $t("プロジェクト") }}を作成していません。</v-card-text>
    </v-card>
    <v-list id="activitylog" v-else class="overflow-x-hidden overflow-y-auto" style="height:75vh;">
      <v-list-item v-for="activity in displayque" :key="activity.id">
        <v-card
          class="d-flex align-center overflow-hidden rounded-sm"
          elevation="2"
          width="90%"
        >
          <v-img
            class="ml-0"
            max-height="65px"
            max-width="10"
            src="../../../assets/png/rectangle3.png"
          ></v-img>
          <span class="ml-4">> {{ activity.title }}</span>
        </v-card>
      </v-list-item>
    </v-list>
    <v-card height="200" elevation="0">
    </v-card>
  </v-main>
</template>
  <script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

export default {
  data() {
    return {
      db: firebase.firestore(),
      displayque: [],
    };
  },
  components: {},
  mounted() {
    this.getlog();
  },
  props: ["profuid", "device"],
  watch: {
    profuid: function (profuid) {
      this.getlog();
    },
  },
  methods: {
    getlog(logclass = null) {
      let myque = [];
      if (logclass == null) {
        let usedday = [];
        let collection = this.db
          .collection("0")
          .doc("config")
          .collection("members")
          .doc(this.profuid)
          .collection("creprjlog")
          .orderBy("date", "desc");
        collection
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              myque.push(doc.data());
            });
          })
          .catch((error) => {
            console.log(
              "アクティビティログの取得でエラーが発生しました",
              error
            );
          });
      }
      this.displayque = myque;
    },
  },
};
</script>
  <style scoped>
.pagetitle {
  font-size: 25px;
  color: #707070;
}
* {
  font-family: mplus-2c-medium;
}
</style>